// 근무표 만들기 근무수정 모달 근무코드 폰트사이즈 유틸
export const getDynamicFontSize = (text: string): string => {
  if (!text) return "15px";

  // 한글 체크 (한글 유니코드 범위)
  const isKorean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(text);

  if (isKorean) {
    // 한글
    return text.length === 1 ? "22px" : "17px";
  } else {
    // 영어
    if (text.length === 1) return "24px";
    if (text.length === 2) return "20px";
    return "13px"; // 3글자 이상
  }
};

// 근무코드 설정 근무코드 폰트사이즈 유틸
export const getSettingShiftCodeFontSize = (text: string): string => {
  if (!text) return "15px";

  // 한글 체크 (한글 유니코드 범위)
  const isKorean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(text);

  if (isKorean) {
    // 한글
    if (text.length === 1) return "21px";
    if (text.length === 2) return "15px";
    return "12px";
  } else {
    // 영어
    if (text.length === 1) return "24px";
    if (text.length === 2) return "18px";
    return "13px"; // 3글자 이상
  }
};

export const getSettingShiftCodeDisplayText = (text: string): string => {
  const trimmed = text.trim();
  if (!trimmed) return "-";
  return trimmed.slice(0, 3);
};

export const getReadableShiftCodeTextColor = (
  hexColor?: string | null
): string => {
  if (!hexColor) return "#ffffff";

  const normalized = hexColor.trim().replace("#", "");
  if (!/^[0-9a-fA-F]{6}$/.test(normalized)) return "#ffffff";

  const [red, green, blue] = [0, 2, 4].map((index) =>
    Number.parseInt(normalized.slice(index, index + 2), 16)
  );
  const brightness = (red * 299 + green * 587 + blue * 114) / 1000;

  return brightness >= 159 ? "#101828" : "#ffffff";
};

// 근무표 내의 폰트사이즈 유틸
export const getScheduleShiftCodeFontSize = (text: string): string => {
  if (!text) return "15px";

  // 한글 체크 (한글 유니코드 범위)
  const isKorean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(text);

  if (isKorean) {
    // 한글
    if (text.length === 1) return "15px";
    if (text.length === 2) return "13px";
    return "12px"; // 3글자 이상
  } else {
    // 영어
    if (text.length === 1) return "15px";
    if (text.length === 2) return "15px";
    return "12px"; // 3글자 이상
  }
};

// 원티드 작성페이지 - 근무 유형 선택 버튼 폰트사이즈
// 한글 두글자이상이면 폰트 24px로 나머지는 일단 30px으로 적용
export const getSelectShiftTypeFontSize = (text: string): string => {
  if (!text) return "30px";

  // 한글 체크 (한글 유니코드 범위)
  const isKorean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(text);

  if (isKorean) {
    if (text.length >= 2) return "24px";
    return "30px";
  } else {
    return "30px";
  }
};

// 원티드 작성페이지 - 근무 유형 선택 버튼 폰트사이즈
// 한글 두글자이상이면 폰트 24px로 나머지는 일단 30px으로 적용
export const getCalendarShiftTypeFontSize = (text: string): string => {
  if (!text) return "32px";

  // 한글 체크 (한글 유니코드 범위)
  const isKorean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(text);

  if (isKorean) {
    if (text.length >= 2) return "25px";
    return "32px";
  } else {
    return "32px";
  }
};
